import spotsEscl from '../locales/es-CL/spots.json';
import spotsEsmx from '../locales/es-MX/spots.json';
import spotsEsco from '../locales/es-CO/spots.json';
import spotsEnus from '../locales/en-US/spots.json';
import spotFormEscl from '../locales/es-CL/spotForm.json';
import spotFormEsmx from '../locales/es-MX/spotForm.json';
import spotFormEsco from '../locales/es-CO/spotForm.json';
import spotFormEnus from '../locales/en-US/spotForm.json';
import spotForm from '../components/SpotForm.vue';
import showAlert from '../alert/alertHandler';
import showConfirmation from '../confirmation/confirmationHandler';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import axios from 'axios';

import LogService from '../services/LogService';
import Container from 'typedi';
export default {
  name: 'Spots',
  components: {
    GoogleMapsApiLoader,
    spotForm
  },
  i18n: {
    messages: {
      'es-CL': {
        spots: spotsEscl,
        spotForm: spotFormEscl,
      },
      'es-MX': {
        spots: spotsEsmx,
        spotForm: spotFormEsmx,
      },
      'es-CO': {
        spots: spotsEsco,
        spotForm: spotFormEsco,
      },
      'en-US': {
        spots: spotsEnus,
        spotForm: spotFormEnus,
      },
    },
  },
  data() {
    return {
      gapi: null,
      temporalSpotPath: null,
      isFilterApplied: false,
      isFilterShown: false,
      isFilterClicked: false,
      dataAccess: null,
      isSpotBusy: false,
      keyword: null,
      cities: [],
      types: [],
      spots: [],
      checkedSpots: [],
      selectedCities: [],
      selectedTypes: null,
      selectedAllSpots: false,
      selectedSpot: null,
      perPage: 10,
      currentPage: 1,
      perPageArchived: 10,
      currentPageArchived: 1,
      pageOptions: [10, 20, 50, 100],
      logService: null,
    };
  },
  created() {
    this.logService = Container.get(LogService);
    GoogleMapsApiLoader({
      libraries: ['places', 'marker'],
      apiKey: this.$store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    this.prepareData();
  },
  methods: {
    async prepareData() {
      this.isSpotBusy = true;
      this.dataAccess = this.$store.getters.dataAccess;
      await this.getDestinations();
      this.isSpotBusy = false;
    },
    async getDestinations() {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/spot`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.spots = response.data.data;
        this.spots.forEach((spot) => {
          if(spot.address.city && spot.address.city.trim() != ""){
            spot.city = spot.address.city;
          }else{
            spot.city = "No definido"
          }
          const address = [spot.address.street, spot.address.city, spot.address.state];
          const filterAddress = address.filter(campo => campo !== null && campo !== '');
          // Unir los campos filtrados en un string separado por comas
          spot.simpleAddress = filterAddress.join(',');
          this.cities.push(spot.city);
          this.types.push(spot.type);
        });
        this.spots = this.orderSpotsByName();
        this.cities = [... new Set(this.cities)];
        this.types = [... new Set(this.types)];
      } catch (e) {
        this.logService.sendError({
          component: "spots",
          message: `getDestinations fallo en su procesamiento ${e.message}`
        });
        this.spots = [];
      }
    },
    orderSpotsByName() {
      return this.spots.slice().sort((a, b) => {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        return 0;
      })
    },
    openMassDeleteModal() {
      this.showModal('confirm-mass-delete');
    },
    async massiveDelete() {
      try {
        this.closeModal('confirm-mass-delete');
        this.isSpotBusy = true;
        this.logService.sendInfo({
          component: "spots",
          message: `massiveDelete a nada de eliminar spots /api/spot/massDelete`,
          data: this.checkedSpots,
        });
        const response = await axios.post(`${this.$store.getters.urlAPI}/api/spot/massDelete`, this.checkedSpots, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          showAlert(this.$t('common.modals.exitoTitulo'), this.$t('spots.massModal.successful.massDelete'), 'success');
          await this.getDestinations();
          this.isSpotBusy = false;
        }
      } catch (e) {
        this.logService.sendError({
          component: "spots",
          message: `massiveDelete fallo en su procesamiento ${e.message}`
        });
        this.isSpotBusy = false;
        console.log(e);
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('spots.massModal.error.massDelete'), 'error');
      }
    },
    async deleteSpot() {
      this.logService.sendInfo({
        component: "spots",
        message: `deleteSpot por eliminar el spot de id ${this.selectedSpot.id}`
      });
      //FIX-Seguridad: Solo se agrega el token.
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      this.isSpotBusy = true;
      let urlDelete = `${this.$store.getters.urlAPI}/api/spot/${this.selectedSpot.id}`;
      await axios
        .delete(urlDelete, config)
        .then((response) => {
          console.log(response);
          this.isSpotBusy = false;
          this.getDestinations();
          showAlert(this.$t('spots.delete.title'), this.$t('spots.delete.body'), 'exito');
        })
        .catch((e) => {
          this.logService.sendError({
            component: "spots",
            message: `deleteSpot fallo en su procesamiento ${e.message}`
          });
          this.isSpotBusy = false;
          showAlert(this.$t('spots.delete.title'), this.$t('spots.delete.error'), 'error');
          console.log('error' + e);
        });
    },
    sendInfoSpot(item){
      this.selectedSpot = item;
      showConfirmation(
        this.$t('spots.delete.title'),
        this.$t('spots.delete.confirm', {name: item.name}),
        async () => {
          await this.deleteSpot();
        },
      )
    },
    detailSpots(item){
      this.selectedSpot = item;
      this.temporalSpotPath = 'edit';
      console.log("spot selecionado ",this.selectedSpot);
      this.showModal('create-temporal-spot-modal');
    },
    async depotToUse(item){
      this.isSpotBusy = true;
      this.selectedSpot = item;
      await this.getDestinations();
      this.isSpotBusy = false;
    },
    closeSpotForm(){
      this.closeModal('create-temporal-spot-modal');
    },
    checkSpots() {
      if (this.selectedAllSpots) {
        this.checkAllSpots();
      } else {
        this.unCheckAllSpots();
      }
    },
    limitTextType(count) {
      return this.$t('spots.limitText',{count: count});
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    openCreate(){
      this.selectedSpot = null;
      this.temporalSpotPath = 'origin';
      this.showModal('create-temporal-spot-modal');
    },
    /**
     * checkea todos los trips que no esten asignados
     */
    checkAllSpots() {
      this.checkedSpots = [];
      for (let spot of this.spots) {
        this.checkedSpots.push(spot.id);
      }
    },
    closeModal(modal) {
      this.$refs[modal].hide();
    },
    unCheckAllSpots() {
      this.checkedSpots = [];
    },
    /**
     * Funciones para desactivar el filtro clickeando fuera de la pantalla
     */
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    firstPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      }
    },
  },
  computed: {
    filtered() {
      let spotFilter = this.spots;
      this.isFilterApplied = false;
      if(this.keyword){
        spotFilter = spotFilter.filter((item)=>{
          if (item.name && item.name.toUpperCase().includes(this.keyword.toUpperCase())) {
            return item;
          }
        })
      }
      if(this.selectedCities && this.selectedCities.length > 0){
        this.isFilterApplied = true;
        spotFilter = spotFilter.filter((item)=>{
          if (item.city && this.selectedCities.includes(item.city)) {
            return item;
          }
        });
      }
      if(this.selectedTypes){
        this.isFilterApplied = true;
        spotFilter = spotFilter.filter((item)=>{
          if (item.type && item.type == this.selectedTypes) {
            return item;
          }
        });
      }
      return spotFilter;
    },
    spotFields() {
      const common = {
        thClass: 'text-center',
        tdClass: 'text-center',
      };
      return [
        {
          key: 'select',
          ...common,
        },
        {
          key: 'name',
          label: this.$t('spots.table.name'),
          ...common,
        },
        {
          key: 'simpleAddress',
          label: this.$t('spots.table.address'),
          ...common,
        },
        {
          key: 'city',
          label: this.$t('spots.table.city'),
          ...common,
        },
        {
          key: 'type',
          label: this.$t('spots.table.type'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('spots.table.actions'),
          ...common,
        },
      ];
    },
  },
};
